import * as React from "react"

import {
  Container,
  Button,
  Alert,
  FormSelect,
  Breadcrumb,
  BreadcrumbItem
} from "shards-react"

import { Row, Col } from "react-bootstrap"

// View
import BrowserView from "../common/browserView"
import MobileView from "../common/mobileView"

import Img1 from "../images/class-promo/1.png"

const routes = require("../data/routes.json")

function OneOnOnePromo(props) {
  const routify = function(url) {
    return "/" + props.slug + url
  }

  return (
    <Container className="pt-3">
      <Row>
        <Col xs={12} md={6}>
          <br />
          <BrowserView>
            <br />
            <br />
          </BrowserView>

          <h3 className="text-dark">A unique online learning experience</h3>

          <p className="pt-4">
            <i className="fas fa-check text-success pr-2"></i>
            <span>Smaller class sizes for individual student attention</span>
          </p>
          <p className="mt-3">
            <i className="fas fa-check text-success pr-2"></i>
            <span>Study notes and exercises on each topic covered</span>
          </p>
          <p className="mt-3">
            <i className="fas fa-check text-success pr-2"></i>
            <span>Weekly assessments, monthly progress reports</span>
          </p>
          <p className="mt-3">
            <i className="fas fa-check text-success pr-2"></i>
            <span>Recorded classes, accessible 24/7</span>
          </p>

          <br />
          <Row>
            <Col xs={6}>
              <Button
                href={routify(routes.programmes)}
                style={{ width: "100%" }}
              >
                Find a Programme
              </Button>
            </Col>
            <Col xs={6}>
              <Button
                href={routify(routes.chat)}
                outline
                style={{ width: "100%" }}
              >
                <i className="fa-solid fa-comments pr-2"></i>
                Let's Chat
              </Button>
            </Col>
          </Row>
        </Col>
        <Col sm={{ order: "last" }} xs={{ order: "first" }}>
          <img style={{ width: "100%" }} src={Img1} />
        </Col>
      </Row>
    </Container>
  )
}

export default OneOnOnePromo
